import React from 'react';
import styles from "./StartYourPathSection.module.css";
import {useTranslation} from "react-i18next";
   
const StartYourPathSection = () => {
const { t } = useTranslation();

 return (
    <section className={styles['startyourpath-section']}>
    <div className={styles['startyourpath-container']}>
        <div className={styles.startyourpath}>
            <h2>{t('startYourPath.title')}</h2>
            <p>{t('startYourPath.slogan')}</p>
        </div>
    </div>
        <div className={styles['social-media-links']}>
            <div className={styles.buttons}>
                <div className={styles['gradient-border']}>
                    <a href="https://www.facebook.com/share/1FkyS9CpLh/?mibextid=wwXIfr" target="_blank"  rel="noreferrer" className={styles.btn}>
                        <span className={styles.iconText}>
                            <span className={`${styles.socialIcon} ${styles.facebookIcon}`} />
                            <span className={styles.whitetogreen}>Facebook</span>
                        </span>
                    </a>
                </div>
                <div className={styles['gradient-border']}>
                    <a href="https://www.instagram.com/kizomba_seym?igsh=MXB4NHg0aGFmdzhpdw==" target="_blank"  rel="noreferrer" className={styles.btn}>
                        <span className={styles.iconText}>
                            <span className={`${styles.socialIcon} ${styles.instagramIcon}`} />
                            <span className={styles.whitetogreen}>Instagram</span>
                        </span>
                    </a>
                </div>
                <div className={styles['gradient-border']}>
                    <a href="https://vk.com/kizomba_seym" target="_blank"  rel="noreferrer" className={styles.btn}>
                        <span className={styles.iconText}>
                            <span className={`${styles.socialIcon} ${styles.vkontakteIcon}`} />
                            <span className={styles.whitetogreen}>VK</span>
                        </span>
                    </a>
                </div>
                <div className={styles['gradient-border']}>
                    <a href="https://t.me/Vital_KizzAI" target="_blank"  rel="noreferrer" className={styles.btn}>
                        <span className={styles.iconText}>
                            <span className={`${styles.socialIcon} ${styles.telegramIcon}`} />
                            <span className={styles.whitetogreen}>Telegram</span>
                        </span>
                    </a>
                </div>
            </div>
        </div>
</section>
    );
};

export default StartYourPathSection;